<template>
  <svg
    fill="currentColor"
    height="13"
    viewBox="0 0 13 13"
    width="13"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.5 7.3125C7.39746 7.3125 8.125 6.58496 8.125 5.6875C8.125 4.79004 7.39746 4.0625 6.5 4.0625C5.60254 4.0625 4.875 4.79004 4.875 5.6875C4.875 6.58496 5.60254 7.3125 6.5 7.3125Z" />
    <path
      d="M5.93125 12.7562C5.85 12.675 2.51875 9.75 2.51875 9.66875C1.38125 8.69375 0.8125 7.23125 0.8125 5.6875C0.8125 2.51875 3.33125 0 6.5 0C9.66875 0 12.1875 2.51875 12.1875 5.6875C12.1875 7.23125 11.6187 8.69375 10.4812 9.75C10.4 9.83125 7.15 12.7563 7.06875 12.8375C6.74375 13.0813 6.25625 13.0813 5.93125 12.7562ZM3.7375 8.69375L6.5 11.1312L9.2625 8.69375C10.075 7.88125 10.5625 6.90625 10.5625 5.76875C10.5625 3.49375 8.775 1.70625 6.5 1.70625C4.225 1.70625 2.4375 3.4125 2.4375 5.6875C2.4375 6.825 2.925 7.88125 3.7375 8.69375C3.7375 8.6125 3.7375 8.6125 3.7375 8.69375Z" />
  </svg>
</template>
